"use client";

import { c as _c } from "react/compiler-runtime";
import { GoogleAnalytics, GoogleTagManager } from "@next/third-parties/google";
import { usePathname } from "next/navigation";
import { getGoogleTagManagerId } from "@/lib/analytics/googleTagManager";
const EXCLUDED_PATHS = new Set(["/faqs"]);
export default function GoogleTrackingScripts() {
  const $ = _c(2);
  const pathname = usePathname();
  if (EXCLUDED_PATHS.has(pathname)) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getGoogleTagManagerId();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const gtmId = t0;
  const gaId = process.env.NEXT_PUBLIC_ANALYTICS_ID;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{gtmId ? <GoogleTagManager gtmId={gtmId} /> : null}{!gtmId && gaId ? <GoogleAnalytics gaId={gaId} /> : null}</>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}